const a = {
  "@ado/base-application": {
    footer: {
      "terms-of-use": (e) => {
        const { normalize: r } = e;
        return r(["Terms of Use"]);
      },
      disclaimer: (e) => {
        const { normalize: r } = e;
        return r(["Disclaimer"]);
      },
      "about-us": (e) => {
        const { normalize: r } = e;
        return r(["About Us"]);
      },
      "cookie-policy": (e) => {
        const { normalize: r } = e;
        return r(["Cookie Policy"]);
      },
      "privacy-policy": (e) => {
        const { normalize: r } = e;
        return r(["Privacy Policy"]);
      },
      "google-privacy-policy": (e) => {
        const { normalize: r } = e;
        return r(["Privacy Policy"]);
      },
      "editorial-policy": (e) => {
        const { normalize: r } = e;
        return r(["Editorial Policy"]);
      },
      consent: (e) => {
        const { normalize: r, interpolate: n, named: o } = e;
        return r([n(o("siteBrand")), " is not a law firm and cannot provide legal advice. We provide information and software and you are responsible for appropriately using this material. ", n(o("copyRight"))]);
      },
      "terms-of-service": (e) => {
        const { normalize: r } = e;
        return r(["Terms of Service"]);
      },
      "use-of-site": (e) => {
        const { normalize: r, interpolate: n, named: o } = e;
        return r(["Your use of this site is subject to our ", n(o("tos")), ", ", n(o("disclaimer")), ", ", n(o("cookiePolicy")), " ", n(o("privacyPolicy")), " and ", n(o("editorialPolicy")), "."]);
      },
      "recaptcha-google": (e) => {
        const { normalize: r, interpolate: n, named: o } = e;
        return r(["This site is protected by reCAPTCHA and the Google ", n(o("googlePrivacyPolicy")), " and ", n(o("googleTos")), " apply."]);
      },
      "all-rights-reserved": (e) => {
        const { normalize: r } = e;
        return r(["All Rights Reserved"]);
      },
      "terms-of-use-title": (e) => {
        const { normalize: r } = e;
        return r(["Terms of Use"]);
      },
      "disclaimer-title": (e) => {
        const { normalize: r } = e;
        return r(["Disclaimer"]);
      },
      "privacy-policy-title": (e) => {
        const { normalize: r } = e;
        return r(["Privacy Policy"]);
      },
      "editorial-policy-title": (e) => {
        const { normalize: r } = e;
        return r(["Editorial Policy"]);
      }
    },
    "footer-links": {
      about: (e) => {
        const { normalize: r } = e;
        return r(["About"]);
      },
      "affilicate-program": (e) => {
        const { normalize: r } = e;
        return r(["Affiliate Program"]);
      },
      blog: (e) => {
        const { normalize: r } = e;
        return r(["Blog"]);
      },
      "business-solutions": (e) => {
        const { normalize: r } = e;
        return r(["Business Solutions"]);
      },
      "cancel-page": (e) => {
        const { normalize: r } = e;
        return r(["Cancel Contracts Here"]);
      },
      careers: (e) => {
        const { normalize: r } = e;
        return r(["Careers"]);
      },
      contact: (e) => {
        const { normalize: r } = e;
        return r(["Contact"]);
      },
      home: (e) => {
        const { normalize: r } = e;
        return r(["Home"]);
      },
      "law-library": (e) => {
        const { normalize: r } = e;
        return r(["Law Library"]);
      },
      "legal-documents": (e) => {
        const { normalize: r } = e;
        return r(["Legal Documents"]);
      },
      "legal-notice": (e) => {
        const { normalize: r } = e;
        return r(["Legal Notice"]);
      },
      resources: (e) => {
        const { normalize: r } = e;
        return r(["Resources"]);
      },
      "white-label-program": (e) => {
        const { normalize: r } = e;
        return r(["White Label Program"]);
      }
    },
    "footer-policy-dialog": {
      "print-document": (e) => {
        const { normalize: r } = e;
        return r(["Print Document"]);
      },
      "save-document": (e) => {
        const { normalize: r } = e;
        return r(["Save Document"]);
      }
    },
    help: (e) => {
      const { normalize: r } = e;
      return r(["Help"]);
    },
    more: (e) => {
      const { normalize: r } = e;
      return r(["More"]);
    },
    or: (e) => {
      const { normalize: r } = e;
      return r(["or"]);
    },
    "help-center": (e) => {
      const { normalize: r } = e;
      return r(["Help Center"]);
    },
    countries: {
      "United States": (e) => {
        const { normalize: r } = e;
        return r(["United States"]);
      },
      Australia: (e) => {
        const { normalize: r } = e;
        return r(["Australia"]);
      },
      Austria: (e) => {
        const { normalize: r } = e;
        return r(["Austria"]);
      },
      Canada: (e) => {
        const { normalize: r } = e;
        return r(["Canada"]);
      },
      "United Kingdom": (e) => {
        const { normalize: r } = e;
        return r(["United Kingdom"]);
      },
      Deutschland: (e) => {
        const { normalize: r } = e;
        return r(["Deutschland"]);
      },
      France: (e) => {
        const { normalize: r } = e;
        return r(["France"]);
      },
      India: (e) => {
        const { normalize: r } = e;
        return r(["India"]);
      },
      Ireland: (e) => {
        const { normalize: r } = e;
        return r(["Ireland"]);
      },
      Mexico: (e) => {
        const { normalize: r } = e;
        return r(["Mexico"]);
      },
      "New Zealand": (e) => {
        const { normalize: r } = e;
        return r(["New Zealand"]);
      },
      Nigeria: (e) => {
        const { normalize: r } = e;
        return r(["Nigeria"]);
      },
      Singapore: (e) => {
        const { normalize: r } = e;
        return r(["Singapore"]);
      },
      Spain: (e) => {
        const { normalize: r } = e;
        return r(["Spain"]);
      }
    },
    header: {
      "chat-online": (e) => {
        const { normalize: r } = e;
        return r(["Chat Online"]);
      },
      "email-us": (e) => {
        const { normalize: r } = e;
        return r(["Email Us"]);
      },
      "create-free-account": (e) => {
        const { normalize: r } = e;
        return r(["Create Free Account"]);
      },
      "sign-in": (e) => {
        const { normalize: r } = e;
        return r(["Sign In"]);
      },
      "search-this-site": (e) => {
        const { normalize: r } = e;
        return r(["Search this site..."]);
      },
      go: (e) => {
        const { normalize: r } = e;
        return r(["Go"]);
      },
      "my-documents": (e) => {
        const { normalize: r } = e;
        return r(["My Documents"]);
      },
      "estate-vault": (e) => {
        const { normalize: r } = e;
        return r(["Estate Vault"]);
      },
      "my-account": (e) => {
        const { normalize: r } = e;
        return r(["My Account"]);
      },
      "sign-out": (e) => {
        const { normalize: r } = e;
        return r(["Sign Out"]);
      },
      "upgrade-account": (e) => {
        const { normalize: r } = e;
        return r(["Upgrade Account"]);
      },
      "all-documents": (e) => {
        const { normalize: r, interpolate: n, named: o } = e;
        return r(["All ", n(o("siteBrand")), " Documents"]);
      },
      All: (e) => {
        const { normalize: r } = e;
        return r(["All"]);
      }
    },
    "sign-in": {
      "already-have-account": (e) => {
        const { normalize: r } = e;
        return r(["Already have an account?"]);
      },
      "create-account-disclaimer": (e) => {
        const { normalize: r, interpolate: n, named: o } = e;
        return r(["All information that you provide is kept completely confidential and will not be released to any other companies. Please view our ", n(o("privacyPolicy")), ", ", n(o("tos")), ", and ", n(o("emailPolicy")), " for further information."]);
      },
      "create-an-account": (e) => {
        const { normalize: r } = e;
        return r(["Create a Free Account"]);
      },
      "create-new-account": (e) => {
        const { normalize: r } = e;
        return r(["Create a New Account"]);
      },
      "create-password": (e) => {
        const { normalize: r } = e;
        return r(["Create Password"]);
      },
      "check-email": (e) => {
        const { normalize: r } = e;
        return r(["Check your email now"]);
      },
      "common-error-message": (e) => {
        const { normalize: r } = e;
        return r(["Sorry, an error has occurred. Please refresh your browser or try again later."]);
      },
      "invalid-password-message": (e) => {
        const { normalize: r } = e;
        return r(["Please enter a valid password."]);
      },
      "invalid-email-message": (e) => {
        const { normalize: r } = e;
        return r(["Please enter a valid email address."]);
      },
      "reset-password-success-first-message": (e) => {
        const { normalize: r, interpolate: n, named: o } = e;
        return r(["We have emailed ", n(o("email")), " instructions on how to create a new password."]);
      },
      "reset-password-success-second-message": (e) => {
        const { normalize: r } = e;
        return r(["Open the email and follow the instructions to continue."]);
      },
      "error-alert-title": (e) => {
        const { normalize: r } = e;
        return r(["Error"]);
      },
      "success-alert-title": (e) => {
        const { normalize: r } = e;
        return r(["Success!"]);
      },
      dialog: {
        "creating-account": (e) => {
          const { normalize: r } = e;
          return r(["Creating Account"]);
        },
        "signing-in": (e) => {
          const { normalize: r } = e;
          return r(["Signing In"]);
        },
        "recovery-email": (e) => {
          const { normalize: r } = e;
          return r(["Sending Recovery Email"]);
        },
        "answer-saved-header": (e) => {
          const { normalize: r, interpolate: n, named: o } = e;
          return r(["Your ", n(o("productName")), " is Saved"]);
        },
        "signed-in": {
          "answer-saved-message": (e) => {
            const { normalize: r, interpolate: n, named: o } = e;
            return r(["Your ", n(o("productName")), " has been saved to your ", n(o("siteBrand")), " account."]);
          }
        },
        "create-account": {
          "answer-saved-message": (e) => {
            const { normalize: r, interpolate: n, named: o } = e;
            return r(["You have created an account with ", n(o("siteBrand")), ". We will send you a confirmation email shortly."]);
          }
        },
        "answer-saved-message1": (e) => {
          const { normalize: r, interpolate: n, named: o } = e;
          return r(["You can return and finish your ", n(o("productName")), " whenever you like."]);
        }
      },
      email: (e) => {
        const { normalize: r } = e;
        return r(["Email"]);
      },
      "email-policy": (e) => {
        const { normalize: r } = e;
        return r(["Email Policy"]);
      },
      "forgot-password": (e) => {
        const { normalize: r } = e;
        return r(["I forgot my password"]);
      },
      "if-you-prefer": (e) => {
        const { normalize: r, interpolate: n, named: o } = e;
        return r(["If you prefer, you can ", n(o("create")), " or ", n(o("return")), "."]);
      },
      "no-account-text": (e) => {
        const { normalize: r } = e;
        return r(["Don't have an account?"]);
      },
      "no-thanks": (e) => {
        const { normalize: r } = e;
        return r(["No Thanks"]);
      },
      password: (e) => {
        const { normalize: r } = e;
        return r(["Password"]);
      },
      "password-email-sent": (e) => {
        const { normalize: r } = e;
        return r(["Password Email Sent"]);
      },
      "password-reset": (e) => {
        const { normalize: r } = e;
        return r(["Password Reset"]);
      },
      "password-reset-instructions": (e) => {
        const { normalize: r } = e;
        return r(["We will email you instructions on how to reset your password."]);
      },
      "return-sign-in": (e) => {
        const { normalize: r } = e;
        return r(["Return to Sign In"]);
      },
      "sign-in": (e) => {
        const { normalize: r } = e;
        return r(["Sign In"]);
      },
      "sign-in-text": (e) => {
        const { normalize: r, interpolate: n, named: o } = e;
        return r(["Sign in to your ", n(o("SiteBrand")), " Account"]);
      },
      "save-document": (e) => {
        const { normalize: r } = e;
        return r(["Save My Document"]);
      },
      "save-product-create-text": (e) => {
        const { normalize: r, interpolate: n, named: o } = e;
        return r(["Save Your ", n(o("productName")), " with a free account"]);
      },
      "save-product-login-text": (e) => {
        const { normalize: r, interpolate: n, named: o } = e;
        return r(["Sign in to save your ", n(o("productName"))]);
      }
    },
    "redirect-prompt": {
      "your-country-is-set-to": (e) => {
        const { normalize: r, interpolate: n, named: o } = e;
        return r(["Your country is set to ", n(o("countryName"))]);
      },
      "change-to": (e) => {
        const { normalize: r, interpolate: n, named: o } = e;
        return r(["Change to ", n(o("countryName"))]);
      },
      "dont-change": (e) => {
        const { normalize: r } = e;
        return r(["Don't Change"]);
      }
    }
  }
};
export {
  a as default
};
//# sourceMappingURL=index.js.map
